import { useTranslation } from 'react-i18next';

import { useExternalHomepageConfig } from '../../../hooks/useExternalHomepageConfig';
import { useLocaleUtils } from '../../../hooks/useLocaleUtils';
import { isRemix } from '../../../utils/ssrUtils';
import { getPathnameWithLocale } from '../../../utils/urlUtils';
import { AnchorWrapper } from './AnchorWrapper';
import { FooterItem } from './types';

export const useHelpNavigationItem = (className: string): FooterItem => {
  const { t } = useTranslation();
  const { getHomepageUrl, getLocalizedZendeskUrl } =
    useExternalHomepageConfig();
  const { currentLocale } = useLocaleUtils();

  return {
    title: t('navbar.help', 'Help'),
    isDropdown: true,
    list: [
      <AnchorWrapper
        className={className}
        key="help-centre"
        url={getLocalizedZendeskUrl()}
      >
        {t('navbar.faqs', 'Help Centre')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="store-locations"
        url={
          isRemix()
            ? getPathnameWithLocale('/store-locations', currentLocale)
            : getHomepageUrl('/store-locations')
        }
      >
        {t('navbar.store_location', 'Find a Store')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="travel-esim"
        url={getHomepageUrl('/travel-esim')}
      >
        {t('navbar.esim_travel', 'Travel eSIM Explained')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="support-esim-activation-guide"
        url={getHomepageUrl('/support/esim-activation-guide')}
      >
        {t('navbar.activation_guide', 'eSIM Activation Guides')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="support-compatible-handsets"
        url={getHomepageUrl('/support/compatible-handsets')}
      >
        {t('navbar.compatible_handsets', 'eSIM Compatible Phones')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="support-phone-unlocking"
        url={getHomepageUrl('/support/phone-unlocking')}
      >
        {t('navbar.phone_unlocking', 'Phone Unlocking')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="support-contact-us"
        url={
          isRemix()
            ? getPathnameWithLocale('/contact-us', currentLocale)
            : '/contact-us'
        }
      >
        {t('navbar.contact_us', 'Customer Support')}
      </AnchorWrapper>,
    ],
  };
};
